import { toast } from "react-toastify";
import {
  apiAgent,
  apiAgentWithToken,
  apiBoom,
  apiPassenger,
  BaseUrl,
} from "../App";
import { getToken, removeToken } from "./token";

const toastError = (error) => {
  if (error.response.status >= 400 && error.response.status !== 500) {
    toast.error(error.response.data.msg);
  }
  if (
    error.response.status >= "406 Not Acceptable" &&
    error.response.status !== 500
  ) {
    toast.error(error.response.data.fields);
  }
};

export async function get(path, token, config) {
  const onSuccess = (response) => {
    return response.data;
  };

  const onError = (error) => {
    toastError(error);
    return Promise.reject(error?.response, error?.message);
  };

  try {
    const response = await (token ? apiAgentWithToken : apiAgent).get(
      path,
      config
    );
    return onSuccess(response);
  } catch (error) {
    if (error.response.status === 401) {
      removeToken();
      window.location.replace("/login");
    }
    return onError(error);
  }
}

export async function delete_(path, token, data, params) {
  const onSuccess = (response) => {
    return response.data;
  };

  const onError = (error) => {
    toastError(error);
    return Promise.reject(error.response, error.message);
  };

  try {
    const response = await (token ? apiAgentWithToken : apiAgent).delete(path, {
      params,
      data,
    });
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
}

export async function post(path, token, data, config) {
  const onSuccess = (response) => {
    return response.data;
  };

  const onError = (error) => {
    toastError(error);
    return Promise.reject(error.response, error.message);
  };

  try {
    const response = await (token ? apiAgentWithToken : apiAgent).post(
      path,
      data,
      config
    );
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
}

export async function patch(
  path,
  token,
  data,
  headers = {
    Authorization: `Bearer ${getToken()}`,
  },
  params
) {
  const onSuccess = (response) => {
    return response.data;
  };

  const onError = (error) => {
    toastError(error);
    return Promise.reject(error.response, error.message);
  };

  try {
    const response = await (token ? apiAgentWithToken : apiAgent).patch(
      path,
      data,
      token ? { headers, params } : { params }
    );
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
}

export async function put(
  path,
  token,
  data,
  headers = {
    Authorization: `Bearer ${getToken()}`,
  },
  params
) {
  const onSuccess = (response) => {
    return response.data;
  };

  const onError = (error) => {
    toastError(error);
    return Promise.reject(error.response, error.message);
  };

  try {
    const response = await (token ? apiAgentWithToken : apiAgent).put(
      path,
      data,
      token ? { headers, params } : { params }
    );
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
}
